/*
  @author: remy sharp / http://remysharp.com
  @params:
    feedback - the selector for the element that gives the user feedback. Note that this will be relative to the form the plugin is run against.
    useInput - whether to look for a hidden input named 'maxlength' instead of the maxlength attribute. Defaults to false.
    disableItem - disable this item if maxlenght is exceeded.
    allowEmpty - if false disable "disableItem" if length == 0.
  @license: Creative Commons License - ShareAlike http://creativecommons.org/licenses/by-sa/3.0/
  @version: 1.2
  @changes: code tidy via Ariel Flesler and fix when pasting over limit and including \t or \n
*/

(function ($) {

    $.fn.maxlength = function (settings) {

        if (typeof settings == 'string') {
            settings = {feedback: settings};
        }

        settings = $.extend({}, $.fn.maxlength.defaults, settings);

        function length(value) {
            var parts = value.replace(/\n/g, '~~');
            return parts.length;
        }

        return this.each(function () {
            var field = this,
                $field = $(field),
                $form = $(field.form),
                limit = settings.useInput ? $form.find('input[name=maxlength]').val() :
                    $field.attr('max-length') ? $field.attr('max-length') : $field.attr('maxlength'),
                $charsLeft = $form.find(settings.feedback),
                $disableButton = $(settings.disableItem);
            var allowEmpty = settings.allowEmpty;
            var charsLeftColor = $charsLeft.css('color');


            var updateCount = function () {
                var len = length(field.value),
                    diff = limit - len;

                $charsLeft.html(diff || "0");

                if (diff < 0) {

                    $charsLeft.css('color', 'red');
                    if ($disableButton.length > 0) {
                        $disableButton.prop('disabled', true);
                    }
                } else {
                    $charsLeft.css('color', charsLeftColor);
                    if ($disableButton.length > 0) {
                        $disableButton.prop('disabled', !allowEmpty && len === 0);
                    }
                }
            };

            $field.on('input', updateCount);
            updateCount();
        });
    };

    $.fn.maxlength.defaults = {
        useInput: false,
        feedback: '.charsLeft',
        allowEmpty: true
    };

})(jQuery);
